import { useState } from "react"

interface ScratchpadProps {
  resetKey?: string
  rows?: number
}

/**
 * Positioned in the left margin of its nearest `relative` parent.
 * The parent must be inside a centered container with enough left margin space.
 */
export function Scratchpad({ resetKey, rows = 16 }: ScratchpadProps) {
  const [value, setValue] = useState("")

  const [prevKey, setPrevKey] = useState(resetKey)
  if (resetKey !== prevKey) {
    setPrevKey(resetKey)
    setValue("")
  }

  return (
    <div className="absolute right-full mr-4 w-96" style={{ top: "2rem" }}>
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Scratchpad — work through the problem here..."
        rows={rows}
        className="w-full rounded-lg border border-border bg-card p-3 text-sm font-mono resize-vertical focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20 placeholder:text-muted-foreground/50"
      />
    </div>
  )
}
